import { z } from 'zod';
import { ErrorResponseSchema } from '@/schemas/common/base';

/**
 * POST /api/listings/[id]/feature request param schema
 * Features or unfeatures a listing (admin only)
 */
export const FeatureListingParamSchema = z.object({
  id: z.string().refine(val => !isNaN(Number(val)), 'Invalid listing ID'),
});

/**
 * POST /api/listings/[id]/feature response schema
 * Returns the new featured status
 */
export const FeatureListingResponseSchema = z.discriminatedUnion('success', [
  z.object({
    success: z.literal(true),
    featured: z.boolean(),
    featuredDate: z.union([z.date(), z.string(), z.null()]),
  }),
  ErrorResponseSchema.extend({
    details: z.string().optional(),
  }),
]);

export type FeatureListingParam = z.infer<typeof FeatureListingParamSchema>;
export type FeatureListingResponse = z.infer<typeof FeatureListingResponseSchema>;

/**
 * Schema for the supplyListings DB record used by the feature endpoint
 */
export const FeatureListingDbSchema = z.object({
  id: z.number(),
  featuredDate: z.date().nullable(),
});

export type FeatureListingDb = z.infer<typeof FeatureListingDbSchema>;
